import type { TermijnDto } from "./types";
import axiosInstance from "../axios";

export const providerTermijnService = {
  /**
   * Mengambil daftar jadwal termijn untuk proyek tertentu
   */
  getTermijns: async (projectId: string): Promise<TermijnDto[]> => {
    const response = await axiosInstance.get(`/v1/provider/manpro/projects/${projectId}/termijns`);
    const content = response.data?.content;
    return Array.isArray(content) ? content : (content?.data || []);
  },

  /**
   * Membuat atau menyimpan ulang jadwal termijn
   */
  createTermijns: async (
    projectId: string,
    termijns: Array<{ title: string; percentage: number; amount: number; due_date?: string }>
  ): Promise<TermijnDto[]> => {
    const response = await axiosInstance.post(`/v1/provider/manpro/projects/${projectId}/termijns`, { termijns });
    const content = response.data?.content;
    return Array.isArray(content) ? content : (content?.data || []);
  },

  /**
   * Mengajukan pencairan dana ke Admin (karena pekerjaan sudah selesai & dana di Escrow)
   */
  requestPayout: async (projectId: string, termijnId: string, notes?: string): Promise<TermijnDto> => {
    const response = await axiosInstance.post(
      `/v1/provider/manpro/projects/${projectId}/termijns/${termijnId}/request-payout`,
      { notes }
    );
    return response.data?.content;
  },
};
